import Footer from "./Footer";
import Header from "./Header";
import Register from "./Register";

function Home() {
  const closeRegisterModal = () => {
    const modalEl = document.getElementById("registerModal");
    if (modalEl) {
      const modalInstance =
        window.bootstrap.Modal.getInstance(modalEl) ||
        new window.bootstrap.Modal(modalEl);

      modalInstance.hide();
    }
  };

  return (
    <>
      <Header />

      <section>
        <div className="position-relative">
          <img
            src="/assets/images/banner.png"
            className="w-100 object-fit-cover object-position-top"
            height="570"
            alt="banner"
          />
          <div className="position-absolute bottom-0 start-0 w-100 dark-gradient-home h-50"></div>
          <div className="col-lg-6 col-11 position-absolute bottom-0 start-50 translate-middle-x text-center text-white pb-8 z-1">
            <h1 className="display-2 text-white fw-bold lh-1 m-0">
              Find your forever <i className="bi bi-heart-fill text-danger"></i>
            </h1>
            <h3 className="mt-2 text-white opacity-75 fw-normal lh-sm">
              Now, chat for free ! &nbsp; Finding your perfect match just became
              easier
            </h3>
            <div className="d-flex justify-content-center mt-4">
              <span
                data-bs-toggle="modal"
                data-bs-target="#registerNow"
                className="btn bg-primary text-white fw-normal fs-4 rounded-pill border-0 px-7"
              >
                Register Now
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-7">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12 d-flex align-items-center pe-3">
              <div>
                <span className="text-uppercase fw-semibold ls-md">
                  GoRishtey App
                </span>
                <h2 className="fw-normal ls-sm text-dark lh-1 mt-1">
                  Download the GoRishtey.com App for Smart, AI-Curated Matches
                  Made Just for You
                </h2>
                <p className="lh-1 lead fw-normal">
                  Connect with your matches anytime, anywhere
                </p>

                <p className="lh-1 fs-4 fw-normal">
                  Point your phone camera at the QR code or use one of the
                  download links below :
                </p>

                <div>
                  <img
                    src="/assets/images/btn-g-play.svg"
                    width="170"
                    className="ms-2"
                  />
                </div>
                <p className="lh-1 fs-4 fw-normal mt-2">
                  Or{" "}
                  <a
                    href="https://play.google.com/store/apps/details?id=com.gorishteyapp&hl=en_SG"
                    target="_blank"
                  >
                    Click Here
                  </a>{" "}
                  to Download GoRishtey Mobile App
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 pb-2">
        <div class="container">
          <div className="bg-light-red rounded-5 p-lg-7 p-4">
            <div class="row">
              <div className="row text-center">
                <div className="col-md-12 px-lg-8">
                  <span className="text-uppercase text-white fw-semibold ls-md"></span>
                  <h2 className="fw-normal ls-sm text-dark lh-1 mt-1">
                    Finding the right life partner is one of life’s most
                    important decisions. At{" "}
                    <span className="fw-bold">GoRishtey.com</span>, we make this
                    journey safe, simple, and successful.
                  </h2>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <div className="col-lg-9 col-12 mt-4">
                <div className="row g-2 justify-content-center align-items-center">
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                      <div className="d-flex align-items-center">
                        <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                          <i class="bi bi-people fs-3 text-primary"></i>
                        </div>
                        <div className="ms-3 w-75">
                          <h3 class="mb-0 text-dark lh-1 fs-4">
                            Verified & Genuine Profiles
                          </h3>
                          <p className="text-secondary lh-1 mt-1 m-0">
                            Every profile is carefully reviewed to ensure trust.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                      <div className="d-flex align-items-center">
                        <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                          <i class="bi bi-heart fs-3 text-primary"></i>
                        </div>
                        <div className="ms-3 w-75">
                          <h3 class="mb-0 text-dark lh-1 fs-4">
                            Personalized Matchmaking
                          </h3>
                          <p className="text-secondary lh-1 mt-1 m-0">
                            Our intelligent matching system connects you with
                            profiles.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                      <div className="d-flex align-items-center">
                        <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                          <i class="bi bi-lightning fs-3 text-primary"></i>
                        </div>
                        <div className="ms-3 w-75">
                          <h3 class="mb-0 text-dark lh-1 fs-4">
                            Privacy & Security
                          </h3>
                          <p className="text-secondary lh-1 mt-1 m-0">
                            Your personal data is protected with advanced
                            security.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                      <div className="d-flex align-items-center">
                        <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                          <i class="bi bi-camera fs-3 text-primary"></i>
                        </div>
                        <div className="ms-3 w-75">
                          <h3 class="mb-0 text-dark lh-1 fs-4">
                            Matches Across Communities
                          </h3>
                          <p className="text-secondary lh-1 mt-1 m-0">
                            We help you find matches across communities.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="registerNow"
        aria-hidden="true"
        data-bs-keyboard="false"
        tabindex="-1"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content rounded-4 border-0">
            <div className="modal-body">
              <Register onClose={closeRegisterModal} />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Home;
